import * as stylex from "@stylexjs/stylex";
import { colors } from "@softmax/design-system/tokens.stylex";
import { WikiAuthorName } from "../wiki-byline";
import { RevisionDate } from "../history/wiki-revision-date";
import { styles } from "../wiki.styles";
import type { WikiRevision, WikiLinkRenderer } from "../wiki-types";

export function WikiPageByline({
  revision,
  renderLink,
  revisionCount,
  onShowHistory,
}: Readonly<{
  revision: WikiRevision;
  renderLink: WikiLinkRenderer;
  revisionCount: number | null;
  onShowHistory(): void;
}>) {
  return (
    <div {...stylex.props(styles.byline)}>
      <span>Last edited by</span>
      <WikiAuthorName author={revision.author} renderLink={renderLink} />
      <span>·</span>
      <RevisionDate iso={revision.createdAt} />
      <span>·</span>
      <button
        type="button"
        onClick={onShowHistory}
        {...stylex.props(localStyles.textButton)}
      >
        {revisionCount !== null
          ? `${revisionCount} ${revisionCount === 1 ? "revision" : "revisions"}`
          : "Revisions"}
      </button>
    </div>
  );
}

const localStyles = stylex.create({
  textButton: {
    borderWidth: 0,
    padding: 0,
    color: "inherit",
    backgroundColor: "transparent",
    fontFamily: "inherit",
    fontSize: "inherit",
    cursor: "pointer",
    textDecoration: "underline",
    textUnderlineOffset: 3,
    outline: {
      default: "none",
      ":focus-visible": `2px solid ${colors.foreground}`,
    },
    outlineOffset: 3,
  },
});
